export default __webpack_public_path__ + "static/media/ed5cf7bb88d7400b064a38a874045fb3@2x.451988ca.png";